import { invitationBannerText } from './banner';
import { adultInvitationBannerText } from './banner2';

export type InvitationVariant = 'children' | 'adults';

export type Invitation = {
  salutation: string;
  variant: InvitationVariant;
};

/** Each entry represents one QR link. This client-side mapping is not secret. */
export const invitations: Record<string, Invitation> = {
  '6h3m5a1': { salutation: 'HALLO EVI!', variant: 'children' },
  '3k9r2v8': { salutation: 'HALLO MIKA!', variant: 'children' },
  '7p4n6x2': { salutation: 'HALLO JANO!', variant: 'children' },
  '8t1q5w9': { salutation: 'HALLO PAUL!', variant: 'children' },
  '4z7c2h6': { salutation: 'HALLO MERT!', variant: 'children' },
  'e6m9a2q': { salutation: 'HALLO EMMA!', variant: 'children' },
  'a9f3k7m': { salutation: 'HALLO HANNAH UND ADRIAN!', variant: 'adults' },
  'u5l8g2n': { salutation: 'HALLO OMA ULLA UND OPA GÜNTER!', variant: 'adults' },
  'i2n6a9w': { salutation: 'HALLO OMA INA UND OPA UWE!', variant: 'adults' },
  's7r4f1k': { salutation: 'HALLO SILKE UND RALF!', variant: 'adults' },
  'a4j8n2r': { salutation: 'HALLO ANDREA UND JONA!', variant: 'adults' },
  'd3j8q5v': { salutation: 'HENRY!', variant: 'children' },
  't6k1p9x': { salutation: 'HALLO THERESA UND KEVIN!', variant: 'adults' }
};

const fallbackInvitation: Invitation = { salutation: 'HALLO!', variant: 'children' };

export function resolveInvitation(search: string): { invitation: Invitation; bannerText: string } {
  const parameters = new URLSearchParams(search);
  const code = [...parameters.entries()].find(([key]) => key.toLowerCase() === 'code')?.[1].toLowerCase();
  const invitation = (code && invitations[code]) || fallbackInvitation;
  const template = invitation.variant === 'adults' ? adultInvitationBannerText : invitationBannerText;
  return { invitation, bannerText: template.replaceAll('{{anrede}}', invitation.salutation) };
}
